import React from 'react';
import { StyledBadge } from './styled';

// eslint-disable-next-line react/prop-types
const StatusBadge = ({ value }) => <StyledBadge label={value} variant="inverse" size="small" />;

export default StatusBadge;
